import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import TableHeaderButton from '@/metrics/components/TableHeaderButton/TableHeaderButton'

import * as Styles from './styles'

const TableHeader = ({ columns, onSort, orderBy }) => {
  const { t } = useTranslation()

  const isColumnSelected = column => Boolean(column.orderBy) && orderBy?.replace('-', '') === column.orderBy

  const getDirection = () => (orderBy?.startsWith('-') ? 'desc' : 'asc')

  const isColumnSortable = column => Boolean(column.orderBy && onSort)

  return (
    <Styles.Container>
      <th />
      <th>
        <Text type="allCapsS">{t('País')}</Text>
      </th>
      {columns.map(column => (
        <th key={column.field}>
          <TableHeaderButton
            onClick={() => onSort(column.orderBy)}
            selected={isColumnSelected(column)}
            direction={getDirection()}
            disabled={!isColumnSortable(column)}
          >
            <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }}>
              {t(column.label)}
            </Text>
          </TableHeaderButton>
        </th>
      ))}
      <th />
    </Styles.Container>
  )
}

export default TableHeader
